import { Box, Button, Container, Paper, Stack, Typography, styled } from '@mui/material';
import titleImage from '../../../assets/images/homepage/homepageTitle.png';
import HeroHeaderSection from '../../../components/ui-component/hero-header/HeroHeader';
import { useNavigate } from 'react-router-dom';
import React, { FC } from 'react';
import { alpha } from '@mui/system';

function HomePage() {
	return (
		<>
			<HeroHeaderSection
				title="Dortmund unterstützt"
				description="Dortmund bietet vielfältige Förderungsprogramme für Bildung, Kultur und Wirtschaft. Diese Programme stärken die lokale Gemeinschaft und fördern Innovation und Weiterentwicklung."
				backgroundImage={titleImage}
			/>
			<Container>
				<Box component="section">
					<Typography variant="h2">Förderangebote kennenlernen</Typography>
					<Typography sx={{ mt: '3rem' }}>
						Die Stadt Dortmund bietet verschiedene Förderungen für Bürger*innen an. So können Bewohner*innen der Stadt
						beispielsweise Zuschüsse für Klimaschutzmaßnahmen beantragen. Auch eine Förderung aus dem Bildungspaket, zum
						Beispiel für den Beitrag im Sportverein oder der Musikschule, können Bürger*innen bei der Stadt beantragen.
						Welche Förderungen es gibt und wie die Voraussetzungen lauten, erfahren Sie auf diesen Seiten.
					</Typography>
				</Box>
			</Container>
			<ProgrammMasonry />
		</>
	);
}

const StyledMasonryContainer = styled(Box)({
	display: 'grid',
	gap: '1rem',
	marginTop: '2rem',
	width: '100%',
	'@media only screen and (min-width: 690px)': {
		gridTemplateColumns: `repeat(2, 1fr)`,
	},
	'@media only screen and (min-width: 900px)': {
		gridTemplateColumns: `repeat(3, 1fr)`,
	},
});
const StyledMasonry = styled(Box)(() => ({
	display: 'flex',
	flexDirection: 'column-reverse',
	backgroundRepeat: 'no-repeat',
	backgroundPosition: 'center',
	backgroundSize: 'cover',
	padding: '2rem',
	cursor: 'pointer',
	borderRadius: '4px',
	width: '100%',
	height: '15rem',
	objectFit: 'cover',
	'@media only screen and (min-width: 1200px)': {
		'&:nth-of-type(1)': {
			width: '47rem',
			height: '32.875rem',
			gridColumn: '1 / span 2',
			gridRow: '1 / span 2',
		},
		'&:nth-of-type(2)': {
			width: '22.688rem',
			height: '15.875rem',
			gridColumn: '3 / 3',
		},
		'&:nth-of-type(3)': {
			width: '22.688rem',
			height: '15.875rem',
			gridColumn: '1',
			gridRow: '3',
		},
		'&:nth-of-type(4)': {
			width: '22.688rem',
			height: '15.875rem',
			gridColumn: '2',
		},
		'&:nth-of-type(5)': {
			width: '22.688rem',
			height: '33rem',
			gridColumn: '3',
			gridRow: '2 / span 2',
		},
		'&:nth-of-type(6)': {
			width: '47.063rem',
			height: '22.5rem',
			gridColumn: '1 / span 2',
		},
		'&:nth-of-type(7)': {
			width: '22.688rem',
			height: '22.5rem',
			gridColumn: '3',
		},
	},
}));

const ProgrammMasonry: FC<{}> = () => {
	const navigate = useNavigate();
	return (
		<>
			<Paper sx={{ padding: '2rem 0', mt: '2.5rem' }} elevation={0}>
				<Container>
					<Stack spacing={3} alignItems={'center'}>
						<StyledMasonryContainer>
							{itemData.map((item, i) => (
								<StyledMasonry key={i} sx={{ backgroundImage: `url("${item.img}")` }}>
									<Stack
										direction={'row'}
										spacing={1}
										alignItems={'center'}
										justifyContent={'flex-start'}
										sx={{
											backgroundColor: (theme) => alpha(theme.palette.common.black, 0.75),
											padding: '8px 32px 8px 16px',
											width: 'fit-content',
										}}
									>
										<Box sx={{ width: '1.4rem', height: '1.4rem', backgroundColor: 'navbar.secondary.active' }}></Box>
										<Typography variant="h4">{item.title}</Typography>
									</Stack>
								</StyledMasonry>
							))}
						</StyledMasonryContainer>

						<Button variant="outlined" onClick={() => navigate('/foerderprogramm')}>
							Alle anzeigen
						</Button>
					</Stack>
				</Container>
			</Paper>
		</>
	);
};

export const itemData = [
	{
		img: '/images/DemoProgramm/Photovoltaikanlagen.png',
		title: 'Photovoltaikanlagen auf Vereinsgebäuden',
	},
	{
		img: '/images/DemoProgramm/BürgerlichesEngagement.png',
		title: 'Bürgerliches Engagement',
	},
	{
		img: '/images/DemoProgramm/DachUndFassaden.png',
		title: 'Dach- und Fassadenbegründung sowie Entsiegelung',
	},
	{
		img: '/images/DemoProgramm/Atelierförderung.png',
		title: 'Atelierförderung',
	},
	{
		img: '/images/DemoProgramm/Filmkultur.png',
		title: 'Filmkultur',
	},
	{
		img: '/images/DemoProgramm/DortmundMachtLauter.png',
		title: 'Dortmund.Maacht.lauter',
	},
	{
		img: '/images/DemoProgramm/Eigentumsförderung.png',
		title: 'Eigentumsförderung',
	},
];

export default HomePage;
